// extracted by mini-css-extract-plugin
module.exports = {"divider":"Divider_divider__3AsRK","sm":"Divider_sm__1qocG","lg":"Divider_lg__2l1ay"};